/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { PressWrapper } from './styles'

const press = [
  {
    logo: '/about-us/press/wwd.svg',
    name: 'WWD',
    height: 30,
    href: 'https://wwd.com/business-news/business-features/glamsquad-personalized-beauty-services-technology-1238870537/',
  },
  {
    logo: '/about-us/press/vogue.svg',
    name: 'Vogue',
    height: 26,
    href: 'https://www.vogue.com/article/beauty-was-art-too-at-the-2026-met-gala',
  },
  {
    logo: '/about-us/press/essence.svg',
    name: 'Essence',
    height: 26,
    href: 'https://www.essence.com/beauty/glamsquad-silk-press-services-textured-hair/',
  },
  {
    logo: '/about-us/press/glossy.svg',
    name: 'Glossy',
    height: 26,
    href: 'https://www.glossy.co/beauty/how-bubble-and-olaplex-are-leveraging-glamsquad-to-bolster-product-launches/',
  },
]

const PressLogos = () => (
  <PressWrapper aria-label="Press features">
    <span className="press-label">As seen in</span>
    <ul className="press-logos">
      {press.map((item) => (
        <li key={item.name} className="press-logo">
          <a
            className="press-logo-link"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Read about Glamsquad in ${item.name}`}
          >
            <img src={item.logo} alt={item.name} style={{ '--logo-h': `${item.height}px` }} />
          </a>
        </li>
      ))}
    </ul>
  </PressWrapper>
)

export default PressLogos
